import React, { useState } from "react";
import { uploadImageToServer } from "../../utils/serverImageUpload";

export default function ImageUrlWithUpload({ label, value, onChange, className = "" }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    setError("");
    setLoading(true);
    try {
      const url = await uploadImageToServer(file);
      onChange(url);
    } catch (err) {
      setError(err.message || "Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={className}>
      {label && <label className="form-label small">{label}</label>}
      <input
        className="form-control form-control-sm"
        placeholder="https://..."
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
      <div className="d-flex flex-wrap align-items-center gap-2 mt-1">
        <input
          type="file"
          className="form-control form-control-sm"
          style={{ maxWidth: 280 }}
          accept="image/jpeg,image/png,image/webp,image/gif"
          disabled={loading}
          onChange={handleFile}
        />
        {loading && <span className="small text-muted">Uploading…</span>}
      </div>
      {error && <div className="alert alert-danger py-1 small mt-1 mb-0">{error}</div>}
    </div>
  );
}
